function PluginPlaceholder() {
  return null;
}

export default PluginPlaceholder;
